import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ForgotPasswordComponent } from '../../../../components/forgot-password/forgot-password.component';
import { UserResultModel } from '../../../../models/userResultModel';
import { AdminService } from '../../../../services/admin.service';
import { SnackbarService } from '../../../../services/snackbar.service';
import { ConfirmDeleteComponent } from './confirm-delete/confirm-delete.component';

@Component({
    selector: 'app-edit-user',
    templateUrl: './edit-user.component.html',
    styleUrls: ['./edit-user.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditUserComponent implements OnInit {
  public user: UserResultModel = this.data;

  editUserForm = new UntypedFormGroup({
    id: new UntypedFormControl(this.user.userId),
    site: new UntypedFormControl('www.shuttlebuss.se'),
    mobile: new UntypedFormControl(this.user.mobile),
    firstname: new UntypedFormControl(this.user.firstname, Validators.required),
    lastname: new UntypedFormControl(this.user.lastname, Validators.required),
    email: new UntypedFormControl(this.user.email, [Validators.required, Validators.email]),
    roles: new UntypedFormControl(this.user.roles),
    accessLevel: new UntypedFormControl(this.user.accessLevel),
    smsVerification: new UntypedFormControl(this.user.smsVerification),
    mabiStaff: new UntypedFormControl(this.user.mabiStaff),
    flygetsDriver: new UntypedFormControl(this.user.flygetsDriver),
    flygetsDashboard: new UntypedFormControl(this.user.flygetsDashboard),
    flygetsParkiflyAdministrator: new UntypedFormControl(this.user.flygetsParkiflyAdministrator),
    flygetsParkingOperator: new UntypedFormControl(this.user.flygetsParkingOperator),
    flygetsParkingAdministrator: new UntypedFormControl(this.user.flygetsParkingAdministrator),
    flygetsShuttleDriver: new UntypedFormControl(this.user.flygetsShuttleDriver),
    flygetsParkingSurveillance: new UntypedFormControl(this.user.flygetsParkingSurveillance),
    scandicStaff: new UntypedFormControl(this.user.scandicStaff),
    qualityStaff: new UntypedFormControl(this.user.qualityStaff),
    apartDirectStaff: new UntypedFormControl(this.user.apartDirectStaff),
    arlandaXPOApartmentsStaff : new UntypedFormControl(this.user.arlandaXPOApartmentsStaff),
    skavstaStaff : new UntypedFormControl(this.user.skavstaStaff),
    skavstaParkiflyAdministrator: new UntypedFormControl(this.user.skavstaParkiflyAdministrator),
    skavstaParkingOperator: new UntypedFormControl(this.user.skavstaParkingOperator),
    skavstaParkingAdministrator: new UntypedFormControl(this.user.skavstaParkingAdministrator),
    skavstaShuttleDriver: new UntypedFormControl(this.user.skavstaShuttleDriver),
    skavstaParkingSurveillance: new UntypedFormControl(this.user.skavstaParkingSurveillance),
    isApproved: new UntypedFormControl(this.user.isApproved)
  });

  rolesOptions = [
    { id: 'C8B02763-3301-4AAC-86F5-A8CB015B77CC', name: 'Administrator' },
    { id: '6B7E07F2-AA3B-4C8E-8CB0-A8CB015B77CC', name: 'SiteAdmin' }
  ];

  accessLevelOptions = [
    { value: -1, viewValue: 'Blokerad Användare' },
    { value: 0, viewValue: 'Medlem' },
    { value: 1, viewValue: 'Admin' }
  ];

  constructor(
    private dialog: MatDialog,
    public adminService: AdminService,
    public dialogRef: MatDialogRef<EditUserComponent>,
    public snackBar: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data: UserResultModel
  ) {}

  ngOnInit() {
    console.log('EditUserComponent', this.user);
  }

  editUser() {
    this.adminService.updateUserDate(this.editUserForm.value).subscribe(
      result => {
        // console.log(result);
        console.warn('EDITED USER', this.editUserForm.value);
        if (result) {
          this.snackBar.openSnackBar('Ändringar sparade, vänligen ladda om sidan', 'OK');
          this.dialogRef.close();
        } else {
          this.snackBar.openSnackBar('Något gick fel, vänligen kontrollera dina uppgifter', 'OK');
        }
      },
      error => {
        console.error(error);
        this.snackBar.openSnackBar('Något gick fel', 'OK');
      }
    );
  }

  cancelForm() {
    this.dialogRef.close();
  }

  openConfirmDelete() {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      data: {
        message: 'Är du säker?',
        buttonText: {
          ok: 'Ja',
          cancel: 'Avbryt'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        // alert('test');
      }
    });
  }

  openForgotPassword() {
    this.dialog.open(ForgotPasswordComponent, {
      width: '350px',
      data: this.user.email
    });
  }
}
